import * as Sentry from '@sentry/angular';

import { getAppEnvironment } from '@customer-portal/utils';

const environment = getAppEnvironment();
if (['acceptance', 'production'].includes(environment)) {
  Sentry.init({
    dsn: 'https://9266f8d30cc6f53dbfaf574c8854809f@o4511031380148224.ingest.de.sentry.io/4511031383228496',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    // sendDefaultPii: true,

    // Enable sending logs to Sentry
    enableLogs: true,

    // Environments segregate issues and events in Sentry to separate production and development errors.
    environment,

    // This enables automatic instrumentation (highly recommended),
    // but is not necessary for purely manual usage
    // If you only want to use custom instrumentation:
    // * Remove the `BrowserTracing` integration
    // * add `Sentry.addTracingExtensions()` above your Sentry.init() call
    integrations: [Sentry.browserTracingIntegration()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.2,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^https:\/\/mijn(-acc)?\.nieuwestroom\.nl/],

    // Add debug information in the console to find issues with Sentry itself (false is the default)
    debug: false,
  });
}
